import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { CoreLogService } from "../../services/log.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs";
import { CoreCOMService } from "../../services/com.service";
import { ContentType } from "../../shared/contentTypes";

@Component({
  selector: "ya-favoritebar",
  templateUrl: "./favoritebar.component.html",
  styleUrls: ["./favoritebar.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FavoritebarComponent implements OnInit, OnDestroy {
  @Input() favoriteBarContent: string;
  @Input() likeStatus: boolean;
  @Input() modelId: number;
  @Input() contentType: ContentType;
  @Input() hasLike: boolean = true; // show Like icon on favorite bar if true
  @Input() contentClickable: boolean = false;
  @Output() onFavoriteClick = new EventEmitter<void>();
  @Output() onContentClick = new EventEmitter<void>();

  private langSubscriber: Subscription;
  constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _coreCOMService: CoreCOMService
    , private _coreLogService: CoreLogService
    , private internationalisationService: InternationalisationService) { }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("FavoritebarComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.langSubscriber = this.internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });
    // me.PushChanges();
  }

  /** click on like icon */
  public likeClick() {
    const me = this;
    if (me.hasLike) {
      me.onFavoriteClick.emit();
    }
  }

  /** by clicking on the  */
  public contentClick() {
    const me = this;
    if (me.contentClickable) {
      me.onContentClick.emit();
    }
  }

  ngOnDestroy(): void {
    const me = this;
    if (me.langSubscriber) {
      me.langSubscriber.unsubscribe();
    }
  }

}
